import { useLocation } from 'react-router-dom';

import { parseQueryParams } from '@/utils/queryParams';

import { AccountSettingsPageQueryParams, AccountSettingsPageTab } from '../types/AccountSettings.types';

const useAccountSettingsPageTab = (): AccountSettingsPageTab => {
    const location = useLocation();
    const queryParams = parseQueryParams<AccountSettingsPageQueryParams>(location.search);

    if (queryParams?.tab === AccountSettingsPageTab.Preferences) {
        return AccountSettingsPageTab.Preferences;
    } else if (queryParams?.tab === AccountSettingsPageTab.Profile) {
        return AccountSettingsPageTab.Profile;
    } else if (queryParams?.tab === AccountSettingsPageTab.TaxCertManagement) {
        return AccountSettingsPageTab.TaxCertManagement;
    }

    return AccountSettingsPageTab.Profile;
};

export default useAccountSettingsPageTab;
